import React, {
  useEffect,
  useRef,
  useState
} from 'react'
import './manage-game.styles.scss';

import {
  useLocation,
  useNavigate,
  useParams
} from 'react-router-dom';
import {
  useDispatch,
  useSelector
} from 'react-redux';
import ManageHeadBar from '@/components/MANAGE-GAME/manage-layout/manage-game-head-bar/manage-head-bar.component';
import ManageLanding from '@/components/MANAGE-GAME/manage-landing.component';
import ManageGameSidebar from '@/components/MANAGE-GAME/manage-layout/manage-game-sidebar/manage-game-sidebar.component';
import {
  getGameDataFromDb,
  getPlayerDataFromDb,
  getUniqueDocumentFromDb,
  getLatestGameMessageFromDb,
  getPlayersFromPlayerDocs,
  getGameElementsFromRtDb,
  getRegsFromDb,
  getLatestGameActivity,
  getActionItemsFromFirebase,
  getCollectionFromDb,
  getGameElementShortList
} from '@/utils/getDataFromDb';
import Modal, {
  ModalAlert,
  ModalConfirm
} from '@/components/modal/modal.component';
import {
  Desktop,
  LargeTablet,
  Mobile,
  Tablet
} from '@/utils/responsiveQueries';
import ManageMobileHeader from '@/components/MANAGE-GAME/manage-layout/manage-game-head-bar/manage-mobile-head.component';
import {
  auth,
  UseCloudFunction
} from '@/utils/firebase.utils';
import Loader from '@/components/loader/loader.comp';
import { testMemberRestrictions } from '@/utils/membershipRestrictions';
import UpgradeRequiredModal from '@/components/SHARED/upgrade-required-modal/upgrade-required-modal.component';
import { off } from 'firebase/database';
import { changeDocumentTitle } from '@/utils/useDocumentTitle';
import FeedbackModal from '@/components/layout-auth/feedback-modal/feedback-modal.component';
import { faLink } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import GameInfoModal from '@/components/SHARED/game-info-modal/game-info-modal.component';
import VideoModal from '@/components/SHARED/video-modal/video-modal.component';
import { setShowUpgradeModal } from '@/state/slices/contentSlice';
import { setGameOwnerMembership } from '@/state/slices/userSlice';
import { useEffectiveMembership } from '@/utils/useEffectiveMembership';

const ManageGamePage = ({
  orgs,
  managingList
}) => {

  const userProfile = useSelector(state => state.userData.userProfile);
  const membership = useSelector(state => state.userData.membership);
  const newPasscode = useSelector(state => state.contentData.newPasscode);
  const showUpgradeModal = useSelector(state => state.contentData.showUpgradeModal);
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [showGameInfoModal, setShowGameInfoModal] = useState(false);
  const { gamePath } = useParams();
  const [gameId, setGameId] = useState(null);
  const [role, setRole] = useState(null);
  // the game-wide restriction gate below runs against the owner's plan, which
  // arrives from checkAccess(). until that lands, a collaborator's own plan
  // would give the wrong answer, so the gate waits on this.
  const [ownerMembershipChecked, setOwnerMembershipChecked] = useState(false);
  const [currentGame, setCurrentGame] = useState(null);
  const [gameDataRetrieved, setGameDataRetrieved] = useState(false);
  const [gameElements, setGameElements] = useState(null);
  const [playerList, setPlayerList] = useState({});
  const [gameStats, setGameStats] = useState(null);
  const [defaultActivityRecords, setDefaultActivityRecords] = useState({});
  const [activityCounts, setActivityCounts] = useState([]);
  const [teamMembers, setTeamMembers] = useState({});
  const [passcodes, setPasscodes] = useState(null);
  const [confirmMessage, setConfirmMessage] = useState(null);
  const [alertMessage, setAlertMessage] = useState(null);
  const [actionItems, setActionItems] = useState(null);
  const [latestMessage, setLatestMessage] = useState(null);
  const [gameManagers, setGameManagers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showIntroVideo, setShowIntroVideo] = useState(false);
  const onApprove = useRef();
  const elementsRef = useRef();
  const playersRef = useRef();
  const activityRef = useRef();
  const actionItemsRef = useRef();
  const gettingDataRef = useRef();
  const activityCountsRef = useRef();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const effectiveMembership = useEffectiveMembership();
  let gameListener;
  let elementsListener;
  let playersListener;
  let playerListListener;
  let activityListener;
  let actionItemsListener;
  let moreActivityListener;
  let statsListener;
  let teamListener;
  let messageListener;
  let activityCountsListener;
  const accessTimeoutRef = useRef();
  const loggedInTimeoutRef = useRef();
  const gameRef = useRef();

  useEffect(() => {
    loggedInTimeoutRef.current = setTimeout(() => {
      const currentlySignedInUser = auth.currentUser;
      // console.log(currentlySignedInUser);
      if (!location.pathname.includes('/preview/manager/') && !currentlySignedInUser) {
        navigate('/logout');
      }
      if (!location.pathname.includes('/preview/manager/') && !gameRef.current) {
        navigate('/404');
      }
    }, 3000);

    let localStorageSize = function () {
      let _lsTotal = 0, _xLen, _x;
      for (_x in localStorage) {
        if (!localStorage.hasOwnProperty(_x)) continue;
        _xLen = (localStorage[_x].length + _x.length) * 2;
        _lsTotal += _xLen;
      }
      return (_lsTotal / 1024).toFixed(2);
    }
    console.log(localStorageSize() + 'kb');

    

    return () => {
      if (gameListener) gameListener();
      if (elementsListener) elementsListener();
      if (playersListener) playersListener();
      if (playerListListener) off(playerListListener);
      if (activityListener) activityListener();
      if (actionItemsListener?.length > 0) {
        for (let unsub of actionItemsListener) {
          off(unsub);
        }
      }
      if (moreActivityListener) moreActivityListener();
      if (statsListener) statsListener();
      if (teamListener) teamListener();
      if (messageListener) messageListener();
      if (activityCountsListener) activityCountsListener();
      if (accessTimeoutRef.current) clearTimeout(accessTimeoutRef.current);
      if (loggedInTimeoutRef.current) clearTimeout(loggedInTimeoutRef.current);
    }
  }, [])

  useEffect(() => {
    console.log('showFeedbackModal', showFeedbackModal);
  }, [showFeedbackModal])

  useEffect(() => {
    if (
      !location.pathname.includes('/activity') &&
      !location.pathname.includes('/transaction/')
    ) {
      window.localStorage.removeItem('activity-list-filter');
      localStorage.removeItem('scrollpoint');
      localStorage.removeItem('totalCount');
    }
  }, [location])

  useEffect(() => {
    if (!managingList || !gamePath || !membership || !userProfile) return;
    // if (accessTimeoutRef.current) clearTimeout(accessTimeoutRef.current);
    // accessTimeoutRef.current = setTimeout(() => {
    //     checkAccess();
    // }, 2000);

    if (
      Object.values(managingList)
        .filter(g => g.path === gamePath).length > 0 &&
      !gameDataRetrieved &&
      !gettingDataRef.current
    ) {
      getGameData();
      gettingDataRef.current = true;
      setGameDataRetrieved(gettingDataRef.current);
    }

  }, [managingList, gamePath, membership, userProfile])

  useEffect(() => {
    if (!newPasscode) return;
    const codes = { ...passcodes }
    codes[newPasscode.playerId] = newPasscode.code;
    setPasscodes({ ...codes });
  }, [newPasscode])

  async function checkAccess() {
    const accessRes = await UseCloudFunction(
      'checkManagerAccess',
      {
        'appId': userProfile.appId,
        'gameId': gameId
      }
    )
    if (!accessRes.success) {
      setConfirmMessage(`Sorry, you don't have access to manage this game.`);
      onApprove.current = () => {
        navigate('/home');
      }
      return;
    }
    // collaborators inherit the owner's plan, so the whole management UI is
    // gated on the owner's tier rather than their own. owners already sit on
    // their own membership, so nothing is stored for them.
    if (accessRes.roles?.includes('owner')) {
      dispatch(setGameOwnerMembership(null));
    } else {
      dispatch(setGameOwnerMembership(
        typeof accessRes.ownerMembership === 'number'
          ? accessRes.ownerMembership
          : null
      ));
    }
    setOwnerMembershipChecked(true);
  }

  // blocks the game when it exceeds what the governing plan allows. for a
  // collaborator the governing plan is the owner's, so this waits for
  // checkAccess() to resolve rather than judging them on their own tier.
  useEffect(() => {
    if (!currentGame || !role || !effectiveMembership) return;
    if (!ownerMembershipChecked) return;
    const testedGame = testMemberRestrictions({
      'gameData': currentGame,
      'membership': effectiveMembership
    })
    if (!testedGame.disabled) return;
    dispatch(setShowUpgradeModal({
      message: role === 'owner'
        ? 'Sorry! Because you are using the Free Plan, you are unable to access ' +
          'this game and its content because it exceeds what the plan allows.'
        : 'Sorry! This game exceeds what the game owner\'s plan allows, so its ' +
          'content cannot be accessed right now. Please contact the game owner.',
      closeButton: false
    }));
  }, [currentGame, role, effectiveMembership, ownerMembershipChecked, dispatch])

  // the owner's tier belongs to the game being managed, not to the session, so
  // it is dropped on the way out and re-resolved for the next game.
  useEffect(() => {
    return () => {
      dispatch(setGameOwnerMembership(null));
    }
  }, [dispatch])

  function getGameData() {
    getGameDataFromDb({
      'gamePath': gamePath,
      'callback': callback,
      'handleListener': handleListener
    })
    async function callback(data) {
      // console.log(data);
      gameRef.current = { ...data };
      setCurrentGame(gameRef.current);
      changeDocumentTitle(`Manage | ${data.gameName}`, data.icon);
      setRole(managingList[data.gameId].role);
      // the plan-restriction gate lives in its own effect below — it has to
      // wait for the owner's membership to arrive from checkAccess(), which
      // does not run until gameId is set at the end of this callback.
      // change var(--primary) to game color
      var r = document.querySelector(':root');
      r.style.setProperty('--primary', data.color);
      r.style.setProperty('--primary-trans', data.color + 'a6');
      if (!gameId) setGameId(data.gameId);

    }
    function handleListener(unsub) {
      gameListener = unsub;
    }
  }

  useEffect(() => {
    if (!gameId) return;
    // a tier resolved for a previous game must not govern this one, so the
    // gate re-arms and waits for this game's checkAccess() to answer.
    setOwnerMembershipChecked(false);
    dispatch(setGameOwnerMembership(null));
    if (
      managingList[gameId].role === 'owner' ||
      managingList[gameId].role === 'manager' ||
      managingList[gameId].role === 'distributor'
    ) {
      getPlayerListFromPlayerDocs(gameId);
      getActionItems(gameId);
    }
    getPasscodes(gamePath);
    getGameElements(gameId);
    getDefaultActivity(gameId);
    getGameStats(gameId);
    getTeamMembers(gameId);
    getLatestMessage(gameId);
    getGameManagers(gameId);
    getActivityCounts(gameId);
    checkAccess();
  }, [gameId])

  function getGameElements(gameId) {
    getGameElementShortList({
      'gameId': gameId,
      'callback': callback,
      'handleListener': handleListener
    })
    function callback(data) {
      // console.log('elements length: ' + JSON.stringify(data).length);
      elementsRef.current = {
        ...elementsRef.current,
        ...data
      }
      setGameElements(elementsRef.current);
      // console.log(elementsRef.current);
    }
    function handleListener(unsub) {
      elementsListener = unsub;
    }
  }

  function getPlayerListFromPlayerDocs(gameId) {
    getPlayersFromPlayerDocs({
      'gameId': gameId,
      'callback': callback,
      'handleListener': handleListener
    })
    function callback(data) {
      let tempList = { ...playersRef.current };
      for (let p of Object.values(data)) {
        if (p.status !== 'active') {
          if (tempList[p.playerId]) {
            delete tempList[p.playerId];
          }
        } else {
          tempList[p.playerId] = p;
        }
      }
      playersRef.current = { ...tempList };
      setPlayerList(playersRef.current);
    }
    function handleListener(unsub) {
      playerListListener = unsub;
    }
  }

  function getPlayerList(gameId) {
    getPlayerDataFromDb({
      'gameId': gameId,
      'callback': callback,
      'handleListener': handleListener
    })
    function callback(data) {
      // console.log(data);
      if (data.status !== 'active') {
        let tempList = { ...playersRef.current };
        if (tempList[data.playerId]) {
          delete tempList[data.playerId];
        }
        playersRef.current = { ...tempList };
        setPlayerList(playersRef.current);
      } else {
        playersRef.current = { ...playersRef.current, ...{ [data.playerId]: data } }
        setPlayerList(playersRef.current);
      }
    }
    function handleListener(unsub) {
      playersListener = unsub;
    }
  }

  function getDefaultActivity(gameId) {
    getLatestGameActivity({
      'gameId': gameId,
      'callback': callback,
      'handleListener': handleListener
    })
    function callback(data) {
      activityRef.current = {
        ...activityRef.current,
        ...{ [data.id]: data }
      };
      setDefaultActivityRecords(activityRef.current);
    }
    function handleListener(unsub) {
      activityListener = unsub;
    }
  }


  function getActionItems(gameId) {
    // console.log('getting action items');
    getActionItemsFromFirebase({
      'gameId': gameId,
      'status': 'pending',
      'callback': callback,
      'handleListener': handleListener
    })
    function callback(data) {
      if (data.autoApproval) return;
      actionItemsRef.current = {
        ...actionItemsRef.current,
        ...{ [data.id]: data }
      }
      setActionItems(actionItemsRef.current);
    }
    function handleListener(unsubArr) {
      actionItemsListener = unsubArr
    }
  }

  function changeActionItemStatus(actionId, status) {
    const el = document.getElementById(`${actionId}-row`);
    if (el) {
      el.style.backgroundColor = '#d4edda';
      el.style.maxHeight = 0;
    }
    const tds = document.getElementsByClassName(`${actionId}-content`);
    for (let td of tds) {
      td.classList.add('shrink');
    }
    const timeout = setTimeout(() => {
      removeRow();
      clearTimeout(timeout);
    }, 500)

    function removeRow() {
      let tempActionItems = { ...actionItemsRef.current };
      if (tempActionItems[actionId]) {
        if (
          status === 'approved' ||
          status === 'declined'
        ) {
          delete tempActionItems[actionId];
        } else {
          tempActionItems[actionId].status = status;
        }
        actionItemsRef.current = { ...tempActionItems };
        setActionItems(actionItemsRef.current);
      }
    }
  }

  function getGameStats(gameId) {
    getUniqueDocumentFromDb({
      "collection": `games/${gameId}/gameStats`,
      "docId": `${gameId}-gameStats`,
      "callback": callback,
      "handleListener": handleListener
    })
    function callback(data) {
      setGameStats(data)
    }
    function handleListener(unsub) {
      statsListener = unsub;
    }
  }

  function getTeamMembers(gameId) {
    getUniqueDocumentFromDb({
      "collection": `games/${gameId}/teamMembers`,
      "docId": `${gameId}-teamMembers`,
      "callback": callback,
      "handleListener": handleListener
    })
    function callback(data) {
      // console.log(data);
      setTeamMembers(data);
    }
    function handleListener(unsub) {
      teamListener = unsub;
    }
  }

  async function getPasscodes(gamePath) {
    const res = await UseCloudFunction(
      'getPrintableData',
      {
        'gamePath': gamePath,
        'userProfile': userProfile,
        'codesOnly': true
      }
    )
    if (res.error) {
      setAlertMessage('There was an error fetching passcodes.')
      return;
    }
    setPasscodes(res.passcodes);
  }

  async function getLatestMessage(gameId) {
    getLatestGameMessageFromDb({
      'gameId': gameId,
      'callback': callback,
      'handleListener': handleListener
    })
    function callback(data) {
      setLatestMessage(data)
    }
    function handleListener(unsub) {
      messageListener = unsub;
    }
  }

  async function getActivityCounts(gameId) {
    getCollectionFromDb({
      "collection": `games/${gameId}/dailyActivityCounts`,
      "callback": callback,
      "handleListener": handleListener
    })
    function callback(data, id) {
      activityCountsRef.current = {
        ...activityCountsRef.current,
        ...{ [id]: data }
      };
      setActivityCounts(activityCountsRef.current);
    }
    function handleListener(unsub) {
      activityCountsListener = unsub;
    }
  }

  async function getGameManagers(gameId) {
    const res = await UseCloudFunction(
      'getGameManagers',
      {
        'gameId': gameId,
        'userProfile': userProfile
      }
    )
    if (res.error) {
      setAlertMessage('There was an error fetching game managers.')
      return;
    }
    setGameManagers([...res.managerList]);
  }

  return (
    <>
      {
        (currentGame)
          ?
          <div className='manage-game-page' style={
            (currentGame.bg.type === 'gradient')
              ?
              { 'background': `linear-gradient(to bottom, ${currentGame.bg.hexTop}, ${currentGame.bg.hexBottom})` }
              :
              { 'backgroundImage': `url("${currentGame.bg.url}")` }
          }>
            <Desktop>
              <ManageHeadBar gameData={currentGame} />
              <div className='manage-content'>
                <ManageGameSidebar
                  gameData={currentGame}
                  actionItems={actionItems}
                  gameElements={gameElements}
                  playerList={playerList}
                  setShowFeedbackModal={setShowFeedbackModal}
                  setShowGameInfoModal={setShowGameInfoModal}
                  orgs={orgs}
                  role={role}
                />
                <ManageLanding
                  gameData={currentGame}
                  gameElements={gameElements}
                  playerList={playerList}
                  defaultActivityRecords={defaultActivityRecords}
                  gameStats={gameStats}
                  actionItems={actionItems}
                  changeActionItemStatus={changeActionItemStatus}
                  teamMembers={teamMembers}
                  passcodes={passcodes}
                  latestMessage={latestMessage}
                  gameManagers={gameManagers}
                  activityCounts={activityCounts}
                  orgs={orgs}
                  role={role}
                />
              </div>
            </Desktop>

            <LargeTablet>
              <ManageHeadBar gameData={currentGame} />
              <div className='manage-content'>
                <ManageGameSidebar
                  gameData={currentGame}
                  actionItems={actionItems}
                  gameElements={gameElements}
                  playerList={playerList}
                  setShowFeedbackModal={setShowFeedbackModal}
                  setShowGameInfoModal={setShowGameInfoModal}
                  orgs={orgs}
                  role={role}
                />
                <ManageLanding
                  gameData={currentGame}
                  gameElements={gameElements}
                  playerList={playerList}
                  defaultActivityRecords={defaultActivityRecords}
                  gameStats={gameStats}
                  actionItems={actionItems}
                  changeActionItemStatus={changeActionItemStatus}
                  teamMembers={teamMembers}
                  passcodes={passcodes}
                  latestMessage={latestMessage}
                  gameManagers={gameManagers}
                  activityCounts={activityCounts}
                  orgs={orgs}
                  role={role}
                />
              </div>
            </LargeTablet>

            <Tablet>
              <ManageHeadBar gameData={currentGame} />
              <div className='manage-content'>
                <ManageGameSidebar
                  gameData={currentGame}
                  actionItems={actionItems}
                  gameElements={gameElements}
                  playerList={playerList}
                  setShowFeedbackModal={setShowFeedbackModal}
                  setShowGameInfoModal={setShowGameInfoModal}
                  orgs={orgs}
                  role={role}
                />
                <ManageLanding
                  gameData={currentGame}
                  gameElements={gameElements}
                  playerList={playerList}
                  defaultActivityRecords={defaultActivityRecords}
                  gameStats={gameStats}
                  actionItems={actionItems}
                  changeActionItemStatus={changeActionItemStatus}
                  teamMembers={teamMembers}
                  passcodes={passcodes}
                  latestMessage={latestMessage}
                  gameManagers={gameManagers}
                  activityCounts={activityCounts}
                  orgs={orgs}
                  role={role}
                />
              </div>
            </Tablet>

            <Mobile>
              <ManageMobileHeader
                gameData={currentGame}
                gameElements={gameElements}
                actionItems={actionItems}
                setShowFeedbackModal={setShowFeedbackModal}
                setShowGameInfoModal={setShowGameInfoModal}
                playerList={playerList}
                orgs={orgs}
                role={role} />
              <ManageLanding
                gameData={currentGame}
                gameElements={gameElements}
                playerList={playerList}
                defaultActivityRecords={defaultActivityRecords}
                gameStats={gameStats}
                actionItems={actionItems}
                changeActionItemStatus={changeActionItemStatus}
                teamMembers={teamMembers}
                passcodes={passcodes}
                latestMessage={latestMessage}
                gameManagers={gameManagers}
                activityCounts={activityCounts}
                orgs={orgs}
                role={role} />
            </Mobile>

            <FeedbackModal
              show={showFeedbackModal}
              cancel={() => setShowFeedbackModal(false)} />
            <ModalAlert
              show={alertMessage}
              cancel={() => setAlertMessage(null)}
              message={alertMessage} />
            <ModalConfirm
              show={confirmMessage}
              cancel={() => setConfirmMessage(null)}
              message={confirmMessage}
              onApprove={onApprove.current}
              noCancel={true} />
            <UpgradeRequiredModal
              show={showUpgradeModal}
              cancel={() => dispatch(setShowUpgradeModal(null))}
              closeButton={showUpgradeModal?.closeButton ?? true}
              message={showUpgradeModal?.message}
            />
            
            {
              (currentGame) &&
              <GameInfoModal
                showGameInfoModal={showGameInfoModal}
                setShowGameInfoModal={setShowGameInfoModal}
                currentGame={currentGame} />
            }
          </div>
          :
          <div className='loading-page'>
            <Loader />
          </div>
      }

    </>
  )
}

export default ManageGamePage